(function(){
  'use strict';

  var sizes=['XS','S','M','L','XL','XXL','3XL','4XL'];
  var widths=[57,60,63,66,69,72,75,78];
  var lengths={
    tee:[69,71,73,75,77,79,81,83],
    hoodie:[66,68,70,72,74,76,78,80]
  };

  function de(value){return String(value).replace('.',',');}

  function recommendation(width,shift){
    var nearest=0;
    var diff=Infinity;
    widths.forEach(function(value,index){
      var current=Math.abs(value-width);
      if(current<diff){diff=current;nearest=index;}
    });
    var index=Math.max(0,Math.min(sizes.length-1,nearest+Number(shift||0)));
    return {index:index,size:sizes[index],width:widths[index]};
  }

  function initStandaloneFit(){
    var page=document.querySelector('[data-wc-size-page]');
    if(!page) return;
    var product=page.querySelector('[data-wc-page-fit-product]');
    var input=page.querySelector('[data-wc-page-fit-width]');
    var style=page.querySelector('[data-wc-page-fit-style]');
    var button=page.querySelector('[data-wc-page-fit-calc]');
    var result=page.querySelector('[data-wc-page-fit-result]');
    var sizeOut=page.querySelector('[data-wc-page-fit-size]');
    var copyOut=page.querySelector('[data-wc-page-fit-copy]');
    if(!product||!input||!style||!button||!result||!sizeOut||!copyOut) return;

    button.addEventListener('click',function(){
      var width=parseFloat(String(input.value||'').replace(',','.'));
      result.hidden=false;
      if(!Number.isFinite(width)||width<50||width>82){
        sizeOut.textContent='Bitte nachmessen';
        copyOut.textContent='Trag eine flach gemessene Breite zwischen 50 und 82 cm ein.';
        return;
      }
      var rec=recommendation(width,style.value);
      var kind=product.value==='hoodie'?'Hoodie':'T-Shirt';
      var key=product.value==='hoodie'?'hoodie':'tee';
      sizeOut.textContent='Startpunkt: '+rec.size;
      copyOut.textContent='Der VACANCY '+kind+' in '+rec.size+' ist '+de(rec.width)+' cm breit und '+de(lengths[key][rec.index])+' cm lang. Vergleiche beide Maße mit deinem Lieblingsstück.';
    });
  }

  function init(){
    initStandaloneFit();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();


